import { FileUp } from 'lucide-react'
import { RequirePermission } from '@/features/auth/guards'
import { StudentImportPage } from '@/pages/imports/StudentImportPage'
import type { AppModule } from '../moduleRegistry'

export const module: AppModule = {
  id: 'imports',
  schoolModule: 'imports',
  routes: {
    admin: [
      {
        path: 'students/import',
        element: (
          <RequirePermission permission="students.manage">
            <StudentImportPage />
          </RequirePermission>
        ),
      },
    ],
  },
  nav: {
    admin: [
      {
        group: 'People',
        order: 5,
        item: {
          label: 'Data import',
          to: '/admin/students/import',
          icon: FileUp,
          permission: 'students.manage',
          keywords: 'csv bulk upload spreadsheet',
        },
      },
    ],
  },
}
